import { Encryption } from "../config/common";
import AxiosClientApi from "./axios.services";

/*==================================================== 
    Auth Routers                                                                              
====================================================== */
// /admin/auth/login
export function login(request) {
    return AxiosClientApi.post('/admin/auth/login', Encryption(request, true))   // done 
}

export function logout(request) {
    return AxiosClientApi.post('/admin/auth/logout', Encryption(request, true))
}

export function dashboardCount(request) {
    return AxiosClientApi.post('/admin/auth/dashboard', Encryption(request, true))   
} 


//  admin edit profile
export function editProfile(request) {
    return AxiosClientApi.post('/admin/auth/edit-myprofile', Encryption(request, true))
}


export function getEditUserDetials(request) {
    return AxiosClientApi.post('/admin/auth/get-profile', Encryption(request, true))
}

export function editAdminDetials(request) {
    return AxiosClientApi.post('/admin/auth/edit-myprofile', Encryption(request, true))
}

export function AdminchangePassowrd(request) {
    return AxiosClientApi.post('/admin/auth/reset-password', Encryption(request, true))
}

export function UserSubscriptionDetails(request) {
    return AxiosClientApi.post('/website/auth/view_subscription_by_id', Encryption(request, true))
}


//---------------------------------------- User/Customer --------------------------------------

export function getUserList(request) {
    return AxiosClientApi.post('/admin/auth/user', Encryption(request, true))
}

export function editUserDetials(request) {
    return AxiosClientApi.post('/admin/auth/block-unblock-user', Encryption(request, true))
}

export function deleteUserDetials(request) {
    return AxiosClientApi.post('/admin/auth/delete-user', Encryption(request, true))
}

export function userDetials(request) { 
    // customer_id required controller me 
    return AxiosClientApi.post('/admin/auth/user_details', Encryption(request, true))
}


export function getUserExportList(request) {
    return AxiosClientApi.post('/admin/auth/get_user_export_list', Encryption(request, true))
}



//  All user username list 

export function getAllUserList(request) {
    return AxiosClientApi.post('/admin/auth/alluser_list', Encryption(request, true))
}


//---------------------------------------- User/Customer --------------------------------------
// -------------------------------Contractor ----------------------------------------------------------------


export function getContractorList(request) {
    return AxiosClientApi.post('/admin/auth/contractor', Encryption(request, true))
}







// -------------------------------Contractor -----------------------------------------------------------------

export function subAdminActiveInactive(request) {
    return AxiosClientApi.post('/v1/admin/auth/sub_admin_active_inactive', Encryption(request, true))
}

// export function dashboardCount(request) {
//     return AxiosClientApi.post('/admin/auth/dashboard', Encryption(request, true))
// }



// ---------------------------category list ----------------------------


export function addbanner(request) {
    return AxiosClientApi.post('/admin/auth/add_banner', Encryption(request, true))
}

export function activeInactiveBanner(request) {
    return AxiosClientApi.post('/admin/auth/block-unblock-banner', Encryption(request, true))
}
export function bannerList(request) {
    return AxiosClientApi.post('/admin/auth/get_banner_list', Encryption(request, true))
}

export function bannerListbyId(request) {
    return AxiosClientApi.post('/admin/auth/get_banner_list_by_id', Encryption(request, true))
}
export function DeleteBanner(request) {
    return AxiosClientApi.post('/admin/auth/delete-banner', Encryption(request, true))
}

export function bannerListExport(request) {
    return AxiosClientApi.post('/admin/auth/get_banner_export_list', Encryption(request, true))
}




// ----------Subscription-----------------

export function addSubscription(request) {
    return AxiosClientApi.post('/admin/subscription/add_subscription', Encryption(request, true))
}


export function editSubscription(request) {
    return AxiosClientApi.post('/admin/subscription/edit_subscription', Encryption(request, true))
}


export function subscriptionList(request) {
    return AxiosClientApi.post('/admin/subscription/subscription_list', Encryption(request, true))
}

export function subscriptionDelete(request) {
    return AxiosClientApi.post('/admin/subscription/delete_subscription', Encryption(request, true))
}


export function activeInactiveSubscription(request) {
    return AxiosClientApi.post('/admin/subscription/active_inactivesubscription', Encryption(request, true))
}

export function SubscriptionExportList(request) {
    return AxiosClientApi.post('/admin/subscription/get_subscription_export_list', Encryption(request, true))
}

// ----------Subscription-----------------



// ----------Notification-----------------

export function NotificationList(request) {
    return AxiosClientApi.post('/admin/notification/notification_list', Encryption(request, true))
}

export function NotificationSend(request) {
    return AxiosClientApi.post('/admin/notification/send_notification', Encryption(request, true))
}
export function NotificationUpdate(request) {
    return AxiosClientApi.post('/admin/notification/update_notification', Encryption(request, true))
}

export function NotificationDelete(request) {
  
    return AxiosClientApi.post('/admin/notification/delete_notification', Encryption(request, true))
}

export function NotificationActiveInactive(request) {
  
    return AxiosClientApi.post('/admin/notification/active_inactive_notification', Encryption(request, true))
}


// ----------Notification-----------------


// ----------price setting-----------------

export function addPriceSetting(request) {
  
    return AxiosClientApi.post('/admin/auth/price_setting', Encryption(request, true))
}


export function PriceSettingList(request) {
  
    return AxiosClientApi.post('/admin/auth/price_setting_list', Encryption(request, true))
}

export function getStateListAPI(request) {
    return AxiosClientApi.post('/admin/auth/state_list', Encryption(request, true))
}

// price_setting_delete


export function PriceSettingDelete(request) {
  
    return AxiosClientApi.post('/admin/auth/price_setting_delete', Encryption(request, true))
}
// price_setting_active_inactive
export function PriceSettingActiveInactive(request) {
  
    return AxiosClientApi.post('/admin/auth/price_setting_active_inactive', Encryption(request, true))
}

// price_setting_exports
export function PriceSettingExports(request) {
  
    return AxiosClientApi.post('/admin/auth/price_setting_exports', Encryption(request, true))
}




export function RepairaddPriceSetting(request) {
  
    return AxiosClientApi.post('/admin/auth/repair_price_setting', Encryption(request, true))
}

// repair_price_setting_list
export function RepairPriceSettingList(request) {
  
    return AxiosClientApi.post('/admin/auth/repair_price_setting_list', Encryption(request, true))
}

// ----------price setting-----------------


// export function editCategory(request) {
//     return AxiosClientApi.post('/admin/auth/edit_category', Encryption(request, true))
// }
export function categoryListExport(request) {
    return AxiosClientApi.post('/admin/auth/get_category_export_list', Encryption(request, true))
}



// ---------------------------category list ----------------------------



// -------------------------------Contact us list -------------------
export function contectUsList(request) {
    return AxiosClientApi.post('/admin/cms/get_contact_us_list', Encryption(request, true))
}

export function deleteContectUs(request) {
    return AxiosClientApi.post('/admin/cms/delete_contact_us', Encryption(request, true))
}

export function editContectUs(request) {
    console.log('adfhsgdfhg');
    return AxiosClientApi.post('/admin/cms/edit_contact_us_data', Encryption(request, true))
}

export function contectUsExportList(request) {
    return AxiosClientApi.post('/admin/cms/get_contact_us_export_list', Encryption(request, true))
}



// -------------------------------Contact us list -------------------







/*==================================================== 
   CMS Pages                                                                           
====================================================== */


// ------------------------------------------ Faq list---------------------------------


export function faqsList(request) {
    return AxiosClientApi.post('/admin/cms/get-faq', Encryption(request, true))
}

export function addFaqs(request) {
    return AxiosClientApi.post('/admin/cms/add-faq', Encryption(request, true))
}

export function ActiveInactiveFaqs(request) {
    return AxiosClientApi.post('/admin/cms/active-inactive-faq', Encryption(request, true))
}

export function deletFaqs(request) {
    return AxiosClientApi.post('/admin/cms/delete-faq', Encryption(request, true))
}



export function ExportFaqlist(request) {
    return AxiosClientApi.post('/admin/cms/get_faq_export_list', Encryption(request, true))
}

// ------------------------------------------ Faq list---------------------------------

export function appContent(request) {
    return AxiosClientApi.post('/admin/cms/app_content', Encryption(request, true))
}

export function editAppContent(request) {
    return AxiosClientApi.post('/admin/cms/edit_app_content', Encryption(request, true))
}

/*==================================================== 
   CMS Pages                                                                           
====================================================== */






/*==================================================== 
   notification Pages                                                                           
====================================================== */


export function notificationList(request) {
    return AxiosClientApi.post('/admin/auth/notification_list', Encryption(request, true))
}


// notification_read_update
export function notification_read_updateList(request) {
    return AxiosClientApi.post('/admin/auth/notification_read_update', Encryption(request, true))
}


/*==================================================== 
   notification Pages                                                                           
====================================================== */
















// -----------------------------Sub Admin manage ----------------------

export function addSubAdmin(request) {
    return AxiosClientApi.post('/v1/admin/auth/add_sub_admin', Encryption(request, true))
}

export function subAdminList(request) {
    return AxiosClientApi.post('/v1/admin/auth/list_sub_admin', Encryption(request, true))
}


export function editSubAdmin(request) {
    return AxiosClientApi.post('/v1/admin/auth/edit_sub_admin', Encryption(request, true))
}

export function deleteSubAdmin(request) {
    return AxiosClientApi.post('/v1/admin/auth/delete_sub_admin', Encryption(request, true))
}

export function subAdminExportList(request) {
    return AxiosClientApi.post('/v1/admin/auth/sub_admin_export_list', Encryption(request, true))
}
/*==================================================== 
    Auth Customer                                                                        
====================================================== */




export function careGiverDetials(request) {
    return AxiosClientApi.post('/v1/admin/user/caregiver_details', Encryption(request, true))
}

export function Childerndetials(request) {
    return AxiosClientApi.post('/v1/admin/user/childern_details', Encryption(request, true))
}









export function ViewFaqDeatils(request) {
    return AxiosClientApi.post('/v1/admin/cms_page/view_faq_details', Encryption(request, true))
}


// get_faq_export_list

export function faqExportList(request) {
    return AxiosClientApi.post('/v1/admin/cms_page/get_faq_export_list', Encryption(request, true))
}









export function contectUs(request) {
    return AxiosClientApi.post('/v1/product/auth/contect_us', Encryption(request, true))
}


export function getCountryList(request) {
    return AxiosClientApi.get('/v1/admin/auth/country_list', Encryption(request, true))
}

export function forgotPassword(request) {
    return AxiosClientApi.post('/v1/product/auth/forgot_password', Encryption(request, true))
}

export function changePassword(request) {
    return AxiosClientApi.post('/v1/product/auth/change_password', Encryption(request, true))
}




export function editChangePassword(request) {
    return AxiosClientApi.post('/v1/product/auth/edit_change_password', Encryption(request, true))
}


export function appContentAPI(request) {
    return AxiosClientApi.get('/v1/admin/dashboard/app_content', Encryption(request, true))
}

export function editAppContentAPI(request) {
    return AxiosClientApi.post('/v1/admin/dashboard/edit_app_content', Encryption(request, true))
}




export function getUserDeviceDetail(request) {
    return AxiosClientApi.post('/v1/admin/user/get_user_device_detail', Encryption(request, true))
}

export function editUserDataAPI(request) {
    return AxiosClientApi.post('/v1/admin/user/edit_user_data', Encryption(request, true))
}


export function addNewCategoryAPI(request) {
    return AxiosClientApi.post('/v1/admin/category/add_new_category', Encryption(request, true))
}

export function getCategoryListAPI(request) {
    return AxiosClientApi.post('/v1/admin/category/get_category_list', Encryption(request, true))
}

export function editCategoryDataAPI(request) {
    return AxiosClientApi.post('/v1/admin/category/edit_category_data', Encryption(request, true))
}

export function getCategoryExportListAPI(request) {
    return AxiosClientApi.post('/v1/admin/category/get_category_export_list', Encryption(request, true))
}

export function addNewSubCategoryAPI(request) {
    return AxiosClientApi.post('/v1/admin/category/add_new_sub_category', Encryption(request, true))
}

export function getSubCategoryListAPI(request) {
    return AxiosClientApi.post('/v1/admin/category/get_sub_category_list', Encryption(request, true))
}

export function editSubCategoryDataAPI(request) {
    return AxiosClientApi.post('/v1/admin/category/edit_sub_category_data', Encryption(request, true))
}

export function getSubCategoryExportListAPI(request) {
    return AxiosClientApi.post('/v1/admin/category/get_sub_category_export_list', Encryption(request, true))
}

export function getCategoryWiseSubCategoryListAPI(request) {
    return AxiosClientApi.post('/v1/admin/category/get_category_wise_sub_category_list', Encryption(request, true))
}

export function addNewProductAPI(request) {
    return AxiosClientApi.post('/v1/admin/product/add_new_product', Encryption(request, true))
}

export function editProductDataAPI(request) {
    return AxiosClientApi.post('/v1/admin/product/edit_product_data', Encryption(request, true))
}

export function getProductListAPI(request) {
    return AxiosClientApi.post('/v1/admin/product/get_product_list', Encryption(request, true))
}

export function getProductExportListAPI(request) {
    return AxiosClientApi.post('/v1/admin/product/get_product_export_list', Encryption(request, true))
}

export function getProductScannedListAPI(request) {
    return AxiosClientApi.post('/v1/admin/product/get_product_scanned_list', Encryption(request, true))
}

export function getContactUsListAPI(request) {
    return AxiosClientApi.post('/v1/admin/contact/get_contact_us_list', Encryption(request, true))
}

export function editContactUsDetailsAPI(request) {
    return AxiosClientApi.post('/v1/admin/contact/edit_contact_us_data', Encryption(request, true))
}

export function getContactUsExportListAPI(request) {
    return AxiosClientApi.post('/v1/admin/contact/get_contact_us_export_list', Encryption(request, true))
}






